const BudgetCheckIcon = ({ className = "" }) => (
    <svg 
        width="24" 
        height="24" 
        viewBox="0 0 24 24" 
        fill="none" 
        xmlns="http://www.w3.org/2000/svg"
        className={className}
    >
        <path 
            d="M4 12.5455L7.92908 17.1175C8.3281 17.5818 9.0469 17.5818 9.44592 17.1175L19 6" 
            stroke="#3871FF" 
            strokeWidth="1.5" 
            strokeLinecap="round" 
            strokeLinejoin="round"
        />
    </svg>
)

export default BudgetCheckIcon